<div class="ant-form-item-control-input">
  <div class="ant-form-item-control-input-content">
    <ng-content></ng-content>
  </div>
  <span class="ant-form-item-children-icon">
    <i *ngIf="nzHasFeedback && iconType" nz-icon [nzType]="iconType"></i>
  </span>
</div>
<div [ngClass]="['ant-form-item-explain', 'ant-form-item-explain-' + status]" *ngIf="innerTip">
  <div>
    <ng-container *nzStringTemplateOutlet="innerTip; context: { $implicit: validateControl }">{{ innerTip }}</ng-container>
  </div>
</div>
<div class="ant-form-item-extra" *ngIf="nzExtra">
  <ng-container *nzStringTemplateOutlet="nzExtra">{{ nzExtra }}</ng-container>
</div>
